import regionMapping from "./regions"

const {
  region1,
  region2,
  region3,
  region4,
  region5,
  region6,
  region7,
  region8,
} = regionMapping

const recipes = {
  [region1]: [
    {
      name: "Shamey Momos",
      img: "https://assets.epicurious.com/photos/624b4b0884b54e68058e2592/1:1/w_700,c_limit/Momos_MAP_033122_31102.jpg",
      url: "https://www.epicurious.com/recipes/food/views/shamey-momos-vegetable-dumplings-tibet",
      recipeImg:
        "https://assets.epicurious.com/photos/624b4b0f857fa7e509238b57/16:9/w_700,c_limit/Momos_RECIPE_033122_31102.jpg",
    },
    {
      name: "Butter Tea",
      img: "https://assets.epicurious.com/photos/6232033f1e79b564b5f7e439/1:1/w_700,c_limit/Su%20Cha%20%E2%80%94%20RECIPE.jpg",
      url: "https://www.epicurious.com/recipes/food/views/su-cha-tibetan-butter-tea",
      recipeImg:
        "https://assets.epicurious.com/photos/6232033f1e79b564b5f7e439/16:9/w_700,c_limit/Su%20Cha%20%E2%80%94%20RECIPE.jpg",
    },
    {
      name: "Thenthuk",
      img: "https://assets.epicurious.com/photos/624cb87084b54e68058e259b/1:1/w_700,c_limit/Thenthuk_MAP_v2_040122_31609.jpg",
      url: "https://www.epicurious.com/recipes/food/views/thenthuk-tibetan-pull-noodle-soup",
      recipeImg:
        "https://assets.epicurious.com/photos/624cb86f6b6eb685b358da28/16:9/w_700,c_limit/Thenthuk_RECIPE_v2_040122_31609.jpg",
    },
    {
      name: "Big Plate Chicken",
      img: "https://assets.epicurious.com/photos/624b2f392a7a421dabeff2dd/1:1/w_700,c_limit/BigPlateChicken_MAP_033022_30911.jpg",
      url: "https://www.epicurious.com/recipes/food/views/big-plate-chicken-xinjiang-style-da-pan-ji",
      recipeImg:
        "https://assets.epicurious.com/photos/624b2f3a38c948e16bcc2d92/16:9/w_700,c_limit/BigPlateChicken_RECIPE_033022_30911.jpg",
    },
  ],
  [region2]: [
    {
      name: "Baoshao Mushrooms",
      img: "https://assets.epicurious.com/photos/624b54c6661e2eee54f49141/1:1/w_700,c_limit/YunnanMushrooms_MAP_040122_31436.jpg",
      url: "https://www.epicurious.com/recipes/food/views/baoshao-mushrooms-grilled-in-banana-leaves",
      recipeImg:
        "https://assets.epicurious.com/photos/624b54c58e2658d4448c2995/16:9/w_700,c_limit/YunnanMushrooms_RECIPE_040122_31436.jpg",
    },
    {
      name: "Little Pot Rice Noodles",
      img: "https://assets.epicurious.com/photos/624b615f84b54e68058e2597/1:1/w_700,c_limit/KummingLittlePotNoodles_MAP_040122_31486.jpg",
      url: "http://www.epicurious.com/recipes/food/views/little-pot-rice-noodles-kunming-yunnan",
      recipeImg:
        "https://assets.epicurious.com/photos/624b61616b6eb685b358da25/16:9/w_700,c_limit/KummingLittlePotNoodles_RECIPE_040122_31468.jpg",
    },
  ],
  [region3]: [
    {
      name: "Salt and Pepper Squid",
      img: "https://assets.epicurious.com/photos/622f9985da41c8e5b2c92d98/1:1/w_700,c_limit/Salt%20and%20Pepper%20Squid%20%E2%80%94%20RECIPE.jpg",
      url: "https://www.epicurious.com/recipes/food/views/salt-and-pepper-squid",
      recipeImg:
        "https://assets.epicurious.com/photos/622f9985da41c8e5b2c92d98/16:9/w_700,c_limit/Salt%20and%20Pepper%20Squid%20%E2%80%94%20RECIPE.jpg",
    },
    {
      name: "Salted Plum Steamed Fish",
      img: "https://assets.epicurious.com/photos/624b2fccba9851949e21cbde/1:1/w_700,c_limit/SaltedPlumSteamedFish_MAP_033022_30871.jpg",
      url: "https://www.epicurious.com/recipes/food/views/salted-plum-steamed-fish",
      recipeImg:
        "https://assets.epicurious.com/photos/624b2f3ddc762409fac9a501/16:9/w_700,c_limit/SaltedPlumSteamedFish_RECIPE_033022_30871.jpg",
    },
    {
      name: "Hainanese Chicken Rice",
      img: "https://assets.epicurious.com/photos/624b6662ba9851949e21cbe5/1:1/w_700,c_limit/hainan-chicken-rice.jpg",
      url: "https://www.epicurious.com/recipes/food/views/hainanese-chicken-rice",
      recipeImg:
        "https://assets.epicurious.com/photos/624b6662ba9851949e21cbe5/16:9/w_700,c_limit/hainan-chicken-rice.jpg",
    },
    {
      name: "Char Siu",
      img: "https://assets.epicurious.com/photos/624b29da6b6eb685b358da0d/1:1/w_700,c_limit/CharSiu_MAP_033022_30817.jpg",
      url: "https://www.epicurious.com/recipes/food/views/char-siu-barbecue-pork",
      recipeImg:
        "https://assets.epicurious.com/photos/624b29dae7a334cf525ed81a/16:9/w_700,c_limit/CharSiu_RECIPE_033022_30817.jpg",
    },
    {
      name: "Youtiao",
      img: "https://assets.epicurious.com/photos/624b58808e2658d4448c2997/1:1/w_700,c_limit/Chinese%20savory%20doughnuts%20%E2%80%94%20RECIPE.jpg",
      url: "https://www.epicurious.com/recipes/food/views/youtiao-chinese-savory-doughnuts",
      recipeImg:
        "https://assets.epicurious.com/photos/624b58808e2658d4448c2997/16:9/w_700,c_limit/Chinese%20savory%20doughnuts%20%E2%80%94%20RECIPE.jpg",
    },
    {
      name: "Shrimp Cheung Fun",
      img: "https://assets.epicurious.com/photos/6011bd4445b1c414ca670ce4/1:1/w_700,c_limit/ShrimpRiceRolls_RECIPE_012521_407_VOG_final.jpg",
      url: "https://www.epicurious.com/recipes/food/views/shrimp-cheung-fun-rice-rolls-nom-wah",
      recipeImg:
        "https://assets.epicurious.com/photos/6011bd4445b1c414ca670ce4/16:9/w_700,c_limit/ShrimpRiceRolls_RECIPE_012521_407_VOG_final.jpg",
    },
  ],
  [region4]: [
    {
      name: "Hot Dry Noodles",
      img: "https://assets.epicurious.com/photos/624b5beb9efdca17a70afda0/1:1/w_700,c_limit/WuhanHotDryNoodles_MAP_040122_31527.jpg",
      url: "https://www.epicurious.com/recipes/food/views/wuhan-hot-dry-noodles",
      recipeImg:
        "https://assets.epicurious.com/photos/624b5beced0f5d5e476e7d7d/16:9/w_700,c_limit/WuhanHotDryNoodles_RECIPE_040122_31527.jpg",
    },
    {
      name: "Fish Head in Chile Sauce",
      img: "https://assets.epicurious.com/photos/624b616ac89de2b0a3d0d1ef/1:1/w_700,c_limit/HunanFishHeads_MAP_033022_30690.jpg",
      url: "https://www.epicurious.com/recipes/food/views/hunan-fish-head-in-chile-sauce",
      recipeImg:
        "https://assets.epicurious.com/photos/624b616ac89de2b0a3d0d1f0/16:9/w_700,c_limit/HunanFishHeads_RECIPE_033022_30690.jpg",
    },
  ],
  [region5]: [
    {
      name: "Sticky Rice Balls",
      img: "https://assets.epicurious.com/photos/623896c29b5e7534055f856f/1:1/w_700,c_limit/sticky-rice-balls_V1_final.jpg",
      url: "https://www.epicurious.com/recipes/food/views/sticky-rice-balls-three-ways-or-tang-yuan-xian-rou-zhi-ma-cai-zhu-you-my-shanghai-betty-liu",
      recipeImg:
        "https://assets.epicurious.com/photos/623896c29b5e7534055f856f/16:9/w_700,c_limit/sticky-rice-balls_V1_final.jpg",
    },
    {
      name: "Sun-Dried and Preserved Greens With Steamed Pork Belly",
      img: "https://assets.epicurious.com/photos/6112ce5da9039e455db45d0a/1:1/w_700,c_limit/SunDriedGreensPorkBelly_RECIPE.jpg",
      url: "https://www.epicurious.com/recipes/food/views/sun-dried-preserved-greens-steamed-pork-belly",
      recipeImg:
        "https://assets.epicurious.com/photos/6112ce5da9039e455db45d0a/16:9/w_700,c_limit/SunDriedGreensPorkBelly_RECIPE.jpg",
    },
    {
      name: "Rice Cake With Mixed Vegetables",
      img: "https://assets.epicurious.com/photos/6011ddac7e21f30fee735024/1:1/w_700,c_limit/RiceCakeVegetables_RECIPE_012521_540.jpg",
      url: "https://www.epicurious.com/recipes/food/views/rice-cake-mixed-vegetables-hsiao-ching-chou",
      recipeImg:
        "https://assets.epicurious.com/photos/6011ddac7e21f30fee735024/16:9/w_700,c_limit/RiceCakeVegetables_RECIPE_012521_540.jpg",
    },
    {
      name: "Yeasted Scallion and Sesame Bing",
      img: "https://assets.epicurious.com/photos/6063507a860a6d62c0cfef2a/1:1/w_700,c_limit/YeastedScallionandSeasameBing_5_INSET_VOG_final.jpg",
      url: "https://www.epicurious.com/recipes/food/views/yeasted-scallion-sesame-bing-qiang-bing",
      recipeImg:
        "https://assets.epicurious.com/photos/6063507a860a6d62c0cfef2a/16:9/w_700,c_limit/YeastedScallionandSeasameBing_5_INSET_VOG_final.jpg",
    },
    {
      name: "Flowering Chives and Pork Slivers",
      img: "https://assets.epicurious.com/photos/6033eca1f739b3f7ecfe8769/1:1/w_700,c_limit/59_Flowering_Chives_and_Pork_Slivers_final.jpg",
      url: "https://www.epicurious.com/recipes/food/views/flowering-chives-pork-slivers-betty-liu",
      recipeImg:
        "https://assets.epicurious.com/photos/6033eca1f739b3f7ecfe8769/16:9/w_700,c_limit/59_Flowering_Chives_and_Pork_Slivers_final.jpg",
    },
    {
      name: "Drunken Chicken",
      img: "https://assets.epicurious.com/photos/624b44e4d6991e363f6653b1/1:1/w_700,c_limit/DrunkenChicken_MAP_033122_31351.jpg",
      url: "https://www.epicurious.com/recipes/food/views/drunken-chicken",
      recipeImg:
        "https://assets.epicurious.com/photos/624b44e492034f1b5f5d69f9/16:9/w_700,c_limit/DrunkenChicken_RECIPE_033122_31351.jpg",
    },
  ],
  [region6]: [
    {
      name: "Concubine’s Chicken",
      img: "https://assets.epicurious.com/photos/6011b7697e21f30fee73501e/1:1/w_700,c_limit/ConcubineChicken_RECIPE_012521_258.jpg",
      url: "https://www.epicurious.com/recipes/food/views/concubines-chicken-with-longevity-noodles-xian-famous-foods",
      recipeImg:
        "https://assets.epicurious.com/photos/6011b7697e21f30fee73501e/16:9/w_700,c_limit/ConcubineChicken_RECIPE_012521_258.jpg",
    },
    {
      name: "Spicy Cumin Chicken Heart Skewers",
      img: "https://assets.epicurious.com/photos/603fa6ce1351c61e9c58b976/1:1/w_700,c_limit/ChickenHeartSkewers_RECIPE_022621_195.jpg",
      url: "https://www.epicurious.com/recipes/food/views/spicy-cumin-chicken-heart-skewers-xian-famous-foods-jason-wang",
      recipeImg:
        "https://assets.epicurious.com/photos/603fa6ce1351c61e9c58b976/16:9/w_700,c_limit/ChickenHeartSkewers_RECIPE_022621_195.jpg",
    },
    {
      name: "Lanzhou Chile Oil",
      img: "https://assets.epicurious.com/photos/624b243aed0f5d5e476e7d60/1:1/w_700,c_limit/ChiliOil_MAP_033022-30591.jpg",
      url: "https://www.epicurious.com/recipes/food/views/lanzhou-chile-oil",
      recipeImg:
        "https://assets.epicurious.com/photos/624b243592034f1b5f5d69f2/1:1/w_700,c_limit/ChiliOil_RECIPE_033022-30591.jpg",
    },
  ],
  [region7]: [
    {
      name: "Mapo Tofu",
      img: "https://assets.epicurious.com/photos/624b45caed0f5d5e476e7d67/1:1/w_700,c_limit/MapoTofu_MAP_033122_31225.jpg",
      url: "https://www.epicurious.com/recipes/food/views/spicy-sichuan-tofu-em-mapo-doufu-em-242878",
      recipeImg:
        "https://assets.epicurious.com/photos/624b45cc1184c47f7e94b17e/16:9/w_700,c_limit/MapoTofu_RECIPE_033122_31225.jpg",
    },
    {
      name: "Fish-Fragrant Eggplant",
      img: "https://assets.epicurious.com/photos/624b45cf1184c47f7e94b180/1:1/w_700,c_limit/FragrantEggplantWithMincedPork_MAP_033122_31163.jpg",
      url: "https://www.epicurious.com/recipes/food/views/fish-fragrant-eggplant-with-minced-pork",
      recipeImg:
        "https://assets.epicurious.com/photos/624b45cddc762409fac9a503/16:9/w_700,c_limit/FragrantEggplantWithMincedPork_RECIPE_033122_31163.jpg",
    },
    {
      name: "Dan Dan Mian",
      img: "https://assets.epicurious.com/photos/624b2f3e661e2eee54f4913c/1:1/w_700,c_limit/DanDanNoodles_MAP_033122_31258.jpg",
      url: "https://www.epicurious.com/recipes/food/views/dan-dan-mian",
      recipeImg:
        "https://assets.epicurious.com/photos/624b2f3c38c948e16bcc2d94/16:9/w_700,c_limit/DanDanNoodles_RECIPE_033122_31258.jpg",
    },
    {
      name: "Ants Climbing a Tree",
      img: "https://assets.epicurious.com/photos/624b37b6857fa7e509238b43/1:1/w_700,c_limit/BraisedPorkVermicelliNoodles_MAP_033122_31137.jpg",
      url: "https://www.epicurious.com/recipes/food/views/ants-climbing-a-tree",
      recipeImg:
        "https://assets.epicurious.com/photos/624b37b61cc1806ab06b52c2/16:9/w_700,c_limit/BraisedPorkVermicelliNoodles_RECIPE_033122_31137.jpg",
    },
  ],
  [region8]: [
    {
      name: "Colorful Dumplings",
      img: "https://assets.epicurious.com/photos/5e345aca91ac540008db5f41/1:1/w_700,c_limit/ColorDumplings_HERO_012920_334.jpg",
      url: "https://www.epicurious.com/expert-advice/how-to-make-colored-rainbow-dumplings-article",
      recipeImg:
        "https://assets.epicurious.com/photos/5e345aca91ac540008db5f41/16:9/w_700,c_limit/ColorDumplings_HERO_012920_334.jpg",
    },
    {
      name: "Lamb and Green Squash Dumplings",
      img: "https://assets.epicurious.com/photos/5e21ff12f620cb000862d2b0/1:1/w_700,c_limit/lamb-and-green-squash-dumplings-helen-you-dumpling-galaxy-cookbook.jpg",
      url: "https://www.epicurious.com/recipes/food/views/crispy-lamb-and-zucchini-dumplings-dumpling-galaxy",
      recipeImg:
        "https://assets.epicurious.com/photos/5e21ff12f620cb000862d2b0/16:9/w_700,c_limit/lamb-and-green-squash-dumplings-helen-you-dumpling-galaxy-cookbook.jpg",
    },
    {
      name: "3 Fruits of the Earth",
      img: "https://assets.epicurious.com/photos/61d31fec5eac2e2624c95a3f/1:1/w_700,c_limit/ElectricRangeWok_HERO_121621_25683.jpg",
      url: "https://www.epicurious.com/recipes/food/views/three-fruits-of-the-earth-disanxian",
      recipeImg:
        "https://assets.epicurious.com/photos/61d31fec5eac2e2624c95a3f/16:9/w_700,c_limit/ElectricRangeWok_HERO_121621_25683.jpg",
    },
  ],
}

export default recipes
